import { SelectNameValue } from 'business/models/CustomModels';
import { RowInfoType } from 'components/customComponents/Controls/RMTable';

export interface PlateTypesInfo {
  [key: number]: {
    type: RowInfoType;
    msg: string;
  };
}
// plate type
export enum PlateTypeEnum {
  'Experiment Plate' = 0,
  'Screen Lot Plate' = 1,
  'Microfluidics' = 2,
  'LCP' = 3,
}

export const PlateTypeOptions: SelectNameValue[] = [
  { name: 'Experiment Plate', value: PlateTypeEnum['Experiment Plate'] },
  { name: 'Screen Lot Plate', value: PlateTypeEnum['Screen Lot Plate'] },
  { name: 'Microfluidics', value: PlateTypeEnum.Microfluidics },
  { name: 'LCP', value: PlateTypeEnum.LCP },
];

export type PlateTypesRowInfo = {
  [key: number]: {
    type: RowInfoType;
    msg: string;
  };
};
